import { mapState, mapActions } from 'vuex'

export default {
  name: 'Alert',
  data () {
    return {
      defaultTitle: '',
      defaultBody: '',
      defaultLabel: '閉じる'
    }
  },
  computed: {
    ...mapState({
      active: state => state.alert.active,
      title: state => state.alert.title,
      body: state => state.alert.body,
      label: state => state.alert.label
    }),
    getTitle () {
      return this.title || this.defaultTitle
    },
    getBody () {
      return this.body || this.defaultBody
    },
    getAcceptLabel () {
      return this.label || this.defaultLabel
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      hide: 'alert/hide'
    }),
    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.hide()
    },
    /**
     * メッセージを許諾する
     */
    acceptMessage () {
      // this.$emit('childs-event', {
      //   accept: true
      // })

      this.hide()
    }
  }
}